import { render, staticRenderFns } from "./BasicExamFindingInfo.vue?vue&type=template&id=ff4d1d7a&"
import script from "./BasicExamFindingInfo.vue?vue&type=script&lang=js&"
export * from "./BasicExamFindingInfo.vue?vue&type=script&lang=js&"
import style0 from "./BasicExamFindingInfo.vue?vue&type=style&index=0&id=ff4d1d7a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports